<script>
  import { closeToast } from '$lib/features/app/modals';
  import { twMerge } from 'tailwind-merge';
  import Icon from './Icon.svelte';

  let { id = undefined, type = 'info', message = undefined } = $props();

  const TYPES = {
    info: 'text-black bg-white',
    success: 'text-green-800 bg-green-500',
    warning: 'text-yellow-800 bg-yellow',
    error: 'text-red-800 bg-error',
  };

  const containerClasses = $derived(
    twMerge(
      'flex justify-between items-center p-4 rounded space-x-2',
      TYPES[type],
    ),
  );
</script>

<div class={containerClasses}>
  <div>
    {message}
  </div>
  <button onclick={() => closeToast(id)} class="flex items-center">
    <Icon icon="close" />
  </button>
</div>
